<ng-container>
  <title
    direction="right"
    [style]="{
      'font-size': '16px',
      color: '#3376F6',
      'margin-bottom': '1.5rem',
    }"
  >
  </title>
  @for (option of options; track option) {
    <checkbox-container>
      <pr-input-checkbox
        [formControlName]="option.value"
        [label]="option.label"
      >
      </pr-input-checkbox>
      @if (option.consulter) {
        <a class="consulter" href="{{ option.consulter }}" target="_blank">
          Consulter
        </a>
      }
    </checkbox-container>
  }
  <!-- <div class="checkbox">
  <pr-checkbox-group
    formControlName="signatureElectronic"
    [options]="options"
    >
  </pr-checkbox-group>
</div> -->
</ng-container>
